import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LombardConfirmationData } from '../entities/lombard-confirmation.entity';
import { Lombard } from '../entities/lombard.entity';

export const lombardActions = createActionGroup({
  source: 'Lombard',
  events: {
    'Load Lombard': emptyProps(),
    'Load FAQs': emptyProps(),
    'Apply For Credit': props<{ credit: number }>(),
    'Load Confirmation Data': emptyProps(),
    'Clear Confirmation Data': emptyProps(),
    'Dismiss Teaser': emptyProps(),
    'Dismiss Offer': emptyProps(),
  },
});

export const lombardApiActions = createActionGroup({
  source: 'Lombard API',
  events: {
    'Load Lombard Success': props<{ lombard: Lombard }>(),
    'Load Lombard Failure': props<{ error: string }>(),
    'Load FAQs Success': props<{ faqs: string[] }>(),
    'Load FAQs Failure': props<{ error: string }>(),
    'Apply For Credit Success': props<{ lombard: Lombard }>(),
    'Apply For Credit Failure': props<{ error: string }>(),
    'Load Confirmation Data Success': props<{ confirmationData: LombardConfirmationData }>(),
    'Load Confirmation Data Failure': props<{ error: string }>(),
    'Dismiss Teaser Success': emptyProps(),
    'Dismiss Teaser Failure': props<{ error: string }>(),
    'Dismiss Offer Success': props<{ lombard: Lombard }>(),
    'Dismiss Offer Failure': props<{ error: string }>(),
  },
});
